import React from "react";
import { Skeleton } from "antd";

// Alternating incoming / outgoing bubbles so the placeholder reads as a
// conversation rather than a generic block. Widths vary to avoid the uniform
// "loading bars" look.
const BUBBLES = [
  { outgoing: false, width: "58%" },
  { outgoing: true, width: "46%" },
  { outgoing: false, width: "38%" },
  { outgoing: true, width: "62%" },
  { outgoing: false, width: "50%" },
];

/**
 * Message-area placeholder shown while the lead list / thread is still loading.
 *
 * Replaces the empty-state copy during loading: "No conversation yet" claimed
 * an outcome we don't know yet, and flashed before the messages arrived.
 */
const ChatSkeleton = () => (
  <div className="flex flex-col gap-4 px-4 py-6" data-testid="chat-skeleton">
    {BUBBLES.map((bubble, index) => (
      <div
        // eslint-disable-next-line react/no-array-index-key
        key={index}
        className={`flex w-full ${bubble.outgoing ? "justify-end" : "justify-start"}`}
      >
        <div className="flex flex-col gap-1" style={{ width: bubble.width }}>
          <Skeleton.Button active block style={{ height: 56, borderRadius: 8 }} />
          {/* Timestamp line — narrow, and aligned to the bubble's side. */}
          <Skeleton.Button
            active
            style={{ height: 10, width: 64 }}
            className={bubble.outgoing ? "self-end" : "self-start"}
          />
        </div>
      </div>
    ))}
  </div>
);

export default ChatSkeleton;
